import ReactGA from 'react-ga4';
import { GA_TRACKING_ID } from '../consts';

const STORAGE_KEY = "cookie_consent";

export const isConsentGiven = () => localStorage.getItem(STORAGE_KEY) === "accepted";

// Initialize Google Analytics - only call after consent is given
export const initGA = () => {
  if (GA_TRACKING_ID && isConsentGiven()) {
    ReactGA.initialize(GA_TRACKING_ID);
  }
};

// Track page views
export const trackPageView = (path) => {
  if (GA_TRACKING_ID && isConsentGiven()) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Track custom events
export const trackEvent = (category, action, label = '', value = 0) => {
  if (GA_TRACKING_ID && isConsentGiven()) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};
